import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "./AssetHelpers"

export const KTSVG = ({ className = "", path, svgClassName = "mh-50px" }) => {
   //console.log("path", path)
   console.log("toAbsoluteUrl(path)", toAbsoluteUrl(path))
    return (
    <span className={`svg-icon ${className}`}>
      <SVG 
        src={toAbsoluteUrl(path)}
         key={`${toAbsoluteUrl(path)}`}
         className={svgClassName}
         onLoad={() => console.log("SVG loaded")}
         onError={(e) => console.error("SVG failed to load", e)}
         />
    </span>
  )
}
